import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const BroomIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g clipPath="url(#clip0_10538_34035)">
            <path
               d="M23.6696 1.9181C24.1101 1.4774 24.1101 0.764781 23.6696 0.328769C23.229 -0.107243 22.5166 -0.111931 22.0807 0.328769L15.7016 6.70017L15.097 6.09538C14.1502 5.14834 12.6878 4.94206 11.5208 5.59373L0.768675 11.5713C0.295284 11.8339 0 12.3355 0 12.8793C0 13.2779 0.159359 13.6576 0.435895 13.9389L10.0631 23.564C10.3443 23.8453 10.724 24 11.1224 24C11.666 24 12.1676 23.7046 12.43 23.2311L18.4013 12.4762C19.0528 11.3041 18.8466 9.84602 17.8998 8.89898L17.2952 8.29419L23.6696 1.9181ZM15.1673 13.667L10.9489 21.2667L6.42125 16.7378L7.26492 14.2108C7.36334 13.9155 7.08212 13.6389 6.79152 13.7373L4.26052 14.5765L2.73723 13.0528L10.3349 8.83335L15.1673 13.667Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_10538_34035">
               <rect
                  width="24"
                  height="24"
                  fill="white"
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default BroomIcon
